import React from 'react'

import { HistoryNode } from '../../common/interface'
import { DataHistoryDelFor } from '../data'
import { Table } from './Table'
import { Title } from './Title'

type Props = {
  data?: HistoryNode<DataHistoryDelFor>[]
  search: string
  setSearch: (value: string) => void
  setExpandedKeys: (value: Record<string, boolean>) => void
  expandedKeys: Record<string, boolean>
}

export const History: React.FC<Props> = ({
  data,
  search,
  setSearch,
  expandedKeys,
  setExpandedKeys,
}) => {
  return (
    <>
      <Title search={search} setSearch={setSearch} />
      <Table
        data={data}
        setSearch={setSearch}
        expandedKeys={expandedKeys}
        setExpandedKeys={setExpandedKeys}
        search={search}
      />
    </>
  )
}
